exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_EventContainer__g6R0H {\n  font-size: 10px;\n  min-height: calc(100vh - 160px); }\n", ""]);

// Exports
exports.locals = {
	"EventContainer": "styles_EventContainer__g6R0H"
};